//import { Inject, Injectable, InjectionToken } from '@angular/core';

// export const BROWSER_STORAGE = new InjectionToken<Storage>('Browser Storage', {
//     providedIn: 'root',
//     factory: () => localStorage,
//   });
  
  //@Injectable()
  export class BrowserStorageService {
    //constructor(@Inject(BROWSER_STORAGE) public storage: Storage) {}
    private storage: any = {};
    getItem(key: string) {
      return this.storage.hasOwnProperty(key) ? this.storage[key] : null;
    }
  
    setItem(key: string, value: string) {
      this.storage[key] = value;
    }
    removeItem(key: string) {
      delete this.storage[key];
    }
  
    clear() {
      this.storage = {};
    }
    key(index) {
      const keys = Object.keys(this.storage);
      return keys[index] || null;
    }
    get length() {
      return Object.keys(this.storage).length;
    }
  }